import React, { useEffect, useState } from "react";
import "./Forms.css";
import { Container, Button, Card, Col, Row, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import dateFormat from "dateformat";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { GetCustomerAllReports } from "../../apis/ReportsAPI";
import { CreateOrder } from "../../apis/OrderAPI";
import * as BsIcons from "react-icons/bs";
import { GetBase64, ShowDocument } from "../../utils/Utility";
import { useAlert } from "react-alert";
import Loader from "../../components/Loader";
import { useSelector } from "react-redux";
import { GetRequestorAddresses } from "../../apis/RequestorAPI";

export default function SubmitOrder() {
  const { user } = useSelector((state) => state.auth);
  const defaultReport = {
    report_name: "Choose Report...",
    report_id: "0",
  };

  const [orderData, setOrderData] = useState({
    orderAddressId: { value: 0, invalid: false, initial: true },
    applicantName: { value: "", invalid: false, initial: true },
    applicantAddress: { value: "", invalid: false, initial: true },
    billingInfo: { value: "", invalid: false, initial: true },
    report: { value: defaultReport, invalid: false, initial: true },
    otherRemark: { value: "", invalid: false, initial: true },
    orderInstruction: { value: "", invalid: false, initial: true },
    attachments: { value: [], invalid: false, initial: true },
  });

  const updateOrderData = (key, value, rf = selectedReportFor) => {
    setOrderData((prevState) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value,
        initial: false,
        invalid:
          key === "report" &&
          value.report_id === "0" &&
          (rf.includes("individual") ||
            rf.includes("corporate") ||
            rf.length === 0)
            ? true
            : key === "attachments" && value.length === 0
            ? true
            : key === "otherRemark" && rf.includes("other") && value === ""
            ? true
            : key !== "report" &&
              key !== "attachments" &&
              key !== "otherRemark" &&
              value === ""
            ? true
            : key === "orderAddressId" && value === 0
            ? true
            : false,
      },
    }));
  };

  const isObjectValid = (obj) => {
    for (const key in obj) {
      console.log(key);
      if (obj.hasOwnProperty(key)) {
        if (
          key !== "billingInfo" &&
          key !== "orderInstruction" &&
          key !== "attachments"
        ) {
          if (obj[key].invalid) {
            return false; // Invalid value found
          } else if (obj[key].initial) {
            updateOrderData(key, obj[key].value);
            return false;
          }
        }
      }
    }
    return true; // All properties have valid values
  };

  const [selectedReportFor, setSelectedReportFor] = useState([]);
  const [reqAddrs, setReqAddrs] = useState([]);

  const defaultReqAddr = {
    id: 0,
    address: "Choose address...",
  };

  const [selectedReqAddr, setSelectedReqAddr] = useState(defaultReqAddr);

  const formDate = dateFormat(new Date(), "mm/dd/yyyy");
  const [reportList, setReportList] = useState([]);
  const [validated, setValidated] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const navigate = useNavigate();
  const alert = useAlert();

  async function GetReqAddress() {
    var result = await GetRequestorAddresses(user.requestorid);
    var data = result.data;
    var addrs = [];
    data.map((item) => {
      addrs.push({ id: item.id, address: item.streetAddress });
    });
    setReqAddrs(addrs);
  }

  async function GetCustomerReports() {
    var result = await GetCustomerAllReports(user.customerid);
    var data = result.data.filter(
      (r) => r.report_id !== 800 && r.report_template_id != 2 && r.report_template_id != null
    );
    setReportList(data);
  }

  useEffect(() => {
    GetCustomerReports();
    GetReqAddress();
  }, []);

  function handleFileChange(event) {
    const files = Array.prototype.slice.call(event.target.files);
    let uploadFiles = [];
    let msg = "";
    files.some((file) => {
      if (
        file.size <= 25000000 &&
        !file.type.includes("application/x-msdownload")
      ) {
        GetBase64(file, (result) => {
          uploadFiles.push({
            documentName: file.name.split(".").slice(0, -1).join("."),
            documentPath: result,
          });
        });
      } else msg += `${file.name} exceeds the limit of 25mb.`;
    });

    if (msg !== "") alert(msg);
    else {
      updateOrderData("attachments", uploadFiles);
    }
  }

  async function generateOrder(event) {
    if (!isObjectValid(orderData)) {
      event.preventDefault();
      event.stopPropagation();
      setValidated(false);
    } else {
      setValidated(true);
      var data = {
        id: 0,
        totalRows: 0,
        orderApplicantName: orderData.applicantName.value,
        orderCoApplicant: "",
        orderCustomerName: "",
        orderCustomerIdRef: user.customerid,
        orderUserIdRef: user.userid,
        orderRequestorIdRef: user.requestorid,
        orderAddress: orderData.applicantAddress.value,
        orderNotes: "",
        orderStartDate: "",
        orderEndDate: "",
        orderPo: "",
        orderInvestigatorId: 0,
        orderRestriction: "",
        investigatorName: "",
        orderAmount: "0",
        orderStatusId: 1,
        orderStatusName: "",
        orderPrelimReportDate: "",
        orderTimestamp: "",
        miscPrice: JSON.stringify([]),
        userName: "",
        requestorName: "",
        reportId: orderData.report.value.report_id,
        reportsName: "",
        reports: JSON.stringify([]),
        individual: selectedReportFor.includes("individual"),
        corporate: selectedReportFor.includes("corporate"),
        other: selectedReportFor.includes("other"),
        otherRemark: orderData.otherRemark.value,
        adminInstruction: "",
        customerInstruction: orderData.orderInstruction.value,
        billingInformation: orderData.billingInfo.value,
        applicantFormId: 0,
        attachments: orderData.attachments.value,
        orderBillingEntity: "",
        orderRef: "",
        requestorAddressId: orderData.orderAddressId.value,
      };

      setShowLoader(true);
      var result = await CreateOrder(data);
      if (result.status === 200) {
        alert.success("Order Created Successfully", {
          onClose: () => {
            navigate("/Customer/Orders");
          },
        });
      } else
        alert.error("Error! Unable to create order", {
          onClose: () => setShowLoader(false),
        });
    }
  }

  const handleCheckboxChange = (event) => {
    const value = event.target.value;
    var srf = [];
    if (selectedReportFor.includes(value)) {
      srf = selectedReportFor.filter((option) => option !== value);
      setSelectedReportFor(srf);
    } else {
      srf = [...selectedReportFor, value];
      setSelectedReportFor(srf);
    }
    updateOrderData("report", orderData.report.value, srf);
    updateOrderData("otherRemark", orderData.otherRemark.value, srf);
  };

  const handleOrderAddress = (e) => {
    setSelectedReqAddr(e);
    updateOrderData("orderAddressId", e.id);
  };

  return (
    <>
      <Container className="mb-5">
        <Row className="page-head-row">
          <Col lg={12} md={12} sm={12}>
            <div className="page-title">
              <h2>Submit Order with Attachments Only</h2>
            </div>
          </Col>
        </Row>

        <Row>
          <Col lg={12}>
            <Card className="orderdetails-card form-other-pages">
              <div className="card-head">
                <div className="card-title h5">
                  <span>New Order</span>{" "}
                </div>
                <Link to="/Customer/Forms" className="back-btn">
                  <BsIcons.BsArrowLeft />
                </Link>
              </div>
              <Form noValidate validated={validated}>
                <Row>
                  <Col lg={7} md={12}>
                    <div className="orderdetails-info submit-order">
                      <div className="orderdetails-info-list">
                        <span>Status:</span> New
                      </div>
                      <div className="orderdetails-info-list">
                        <span>Form Date:</span> {formDate}
                      </div>
                      <div className="orderdetails-info-list">
                        <span>Order Address:</span>
                        <div className="billing-info">
                          <DropDownList
                            className="form-control custom-form-control-select"
                            data={reqAddrs}
                            textField="address"
                            dataItemKey="id"
                            defaultItem={defaultReqAddr}
                            value={selectedReqAddr}
                            onChange={(e) => handleOrderAddress(e.target.value)}
                          />
                          <div
                            className="invalid-dropdown"
                            hidden={
                              !orderData.orderAddressId.invalid ||
                              orderData.orderAddressId.initial
                            }
                          >
                            this is required field
                          </div>
                        </div>
                      </div>
                      <div className="orderdetails-info-list">
                        <span>Applicant*:</span>
                        <Form.Group className="" controlId="Applicant">
                          <Form.Control
                            type="text"
                            placeholder="Applicant"
                            value={orderData.applicantName.value}
                            onChange={(e) =>
                              updateOrderData("applicantName", e.target.value)
                            }
                            isInvalid={
                              orderData.applicantName.invalid &&
                              !orderData.applicantName.initial
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            this is required field
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                      <div className="orderdetails-info-list">
                        <span>Address*:</span>
                        <Form.Group className="" controlId="Address">
                          <Form.Control
                            type="text"
                            placeholder="Address"
                            value={orderData.applicantAddress.value}
                            onChange={(e) =>
                              updateOrderData(
                                "applicantAddress",
                                e.target.value
                              )
                            }
                            isInvalid={
                              orderData.applicantAddress.invalid &&
                              !orderData.applicantAddress.initial
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            this is required field
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                      <div className="orderdetails-info-list">
                        <span>Billing Information:</span>
                        <div className="billing-info">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlTextarea1"
                          >
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={orderData.billingInfo.value}
                              onChange={(e) =>
                                updateOrderData("billingInfo", e.target.value)
                              }
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col lg={5} md={12}>
                    <div className="orderdetails-info submit-order">
                      <div className="orderdetails-info-list">
                        <span>Report Type:</span>
                        <DropDownList
                          className="form-control custom-form-control-select"
                          data={reportList}
                          textField="report_name"
                          dataItemKey="report_id"
                          defaultItem={defaultReport}
                          value={orderData.report.value}
                          onChange={(e) =>
                            updateOrderData("report", e.target.value)
                          }
                        />
                        <div
                          className="invalid-dropdown"
                          hidden={
                            !orderData.report.invalid ||
                            orderData.report.initial
                          }
                        >
                          required if report for indiv/corp
                        </div>
                      </div>
                      <div className="orderdetails-info-list">
                        <span>Report For:</span>
                        <div className="chkbx">
                          <Form.Group controlId="ReportFor" className="mb-3">
                            <Form.Check
                              type="checkbox"
                              inline
                              label="Individual"
                              value="individual"
                              checked={selectedReportFor.includes("individual")}
                              onChange={handleCheckboxChange}
                            />
                            <Form.Check
                              type="checkbox"
                              inline
                              label="Corporate"
                              value="corporate"
                              checked={selectedReportFor.includes("corporate")}
                              onChange={handleCheckboxChange}
                            />
                            <Form.Check
                              type="checkbox"
                              inline
                              label="Other"
                              value="other"
                              checked={selectedReportFor.includes("other")}
                              onChange={handleCheckboxChange}
                            />
                            {selectedReportFor.includes("other") && (
                              <>
                                <Form.Control
                                  as="textarea"
                                  rows={3}
                                  placeholder="Other Remark"
                                  value={orderData.otherRemark.value}
                                  onChange={(e) =>
                                    updateOrderData(
                                      "otherRemark",
                                      e.target.value
                                    )
                                  }
                                  isInvalid={
                                    orderData.otherRemark.invalid &&
                                    !orderData.otherRemark.initial
                                  }
                                />
                                <Form.Control.Feedback type="invalid">
                                  required if chosen other
                                </Form.Control.Feedback>
                              </>
                            )}
                          </Form.Group>
                        </div>
                      </div>
                      <div className="orderdetails-info-list">
                        <span>Attachment(s):</span>
                        <Form.Group controlId="formFile" className="mb-3">
                          <Form.Control
                            type="file"
                            onChange={handleFileChange}
                            multiple
                          />
                        </Form.Group>
                        {orderData.attachments.value.map((item, i) => (
                          <p key={i}>
                            <Link
                              onClick={() => ShowDocument(item.documentPath)}
                            >
                              {item.documentName}
                            </Link>
                          </p>
                        ))}
                      </div>
                      <div className="orderdetails-info-list">
                        <span>Other Instructions:</span>
                        <div className="other-intruction">
                          <Form.Group
                            className="mb-3"
                            controlId="exampleForm.ControlTextarea1"
                          >
                            <Form.Control
                              as="textarea"
                              rows={3}
                              value={orderData.orderInstruction.value}
                              onChange={(e) =>
                                updateOrderData(
                                  "orderInstruction",
                                  e.target.value
                                )
                              }
                            />
                          </Form.Group>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className="text-center mt-5">
                    <Button
                      type="button"
                      className="view-report-btn"
                      onClick={generateOrder}
                    >
                      Submit as Order
                      <Loader visible={showLoader} ibutton={true} />
                    </Button>
                  </Col>
                </Row>
              </Form>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
